<template>
  <div></div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "logout",
  created() {
    this.doLogout();
  },
  computed: {
    ...mapGetters(["user"])
  },
  methods: {
    ...mapActions(["userLogout"]),
    async doLogout() {
      this.$store.commit("SHOW_LOADER", true);
      if (this.user && this.user.id) {
        try {
          await this.$api.logUserlogoutFact(this.user.id);
        } catch (error) {
          console.error("There was an error while trying to log out the user");
          console.error(error);
        }
      }
      this.userLogout(true);
      this.$router.push({ name: "login" });
    }
  }
};
</script>
